import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

export function SuccessPage() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [countdown, setCountdown] = useState(5)

  const sessionId = searchParams.get('session_id')

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          navigate('/subscriptions/manage')
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#E8E4F0] to-[#D6E5F0] p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="flex justify-center mb-4">
            <svg
              className="w-16 h-16 text-[#63C36F]"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <CardTitle className="text-center">{t('success.paymentSuccessful')}</CardTitle>
          <CardDescription className="text-center">
            {t('success.subscriptionActivated')}
          </CardDescription>
        </CardHeader>
        <CardContent>
          {sessionId && (
            <p className="text-sm text-[#6D6D6D] text-center mb-4 break-all">
              {t('success.sessionId')} {sessionId}
            </p>
          )}
          <p className="text-center text-[#6D6D6D]">
            {t('success.redirectingIn', { seconds: countdown })}
          </p>
        </CardContent>
        <CardFooter className="flex justify-center">
          <Button onClick={() => navigate('/subscriptions/manage')}>
            {t('success.viewMySubscriptions')}
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}
